import { GenericIcon } from '@/features/GenericIcon/GenericIcon';
import { generatePopupConfig } from '../helpers/generatePopupConfig';
import { FooterOptions, GameErrorType, PopupTypes } from '../types';
import { usePopup } from '../usePopup';
import {
  getIconProductType,
  ResponsibleGamblingType,
} from '@/features/GenericIcon/types';
import { POPUP_TYPES } from '../constants';
import { useStore } from '@/store/useStore';

const HIDE_FOOTER_ERROR_CODES = ['INSUFFICIENT_FUND', 'INSUFFICIENT_FUNDS'];

const PopupFooter: React.FC<{
  footerOptions: FooterOptions;
  errorType: GameErrorType;
  errorCode?: string;
  errorMessage?: string;
  /** The popup this footer belongs to, so "back" can rebuild the originating popup. */
  originType?: PopupTypes;
}> = ({ footerOptions, errorType, errorCode, errorMessage, originType }) => {
  const { showPopup, hidePopup } = usePopup();
  const region = useStore((s) => s.runtime.region);

  const backToOrigin = originType ?? POPUP_TYPES.PROVIDER;

  const secondaryPopupCallback = () => {
    hidePopup();
    showPopup(
      generatePopupConfig(backToOrigin, {
        errorConfig: {
          errorType,
          errorCode,
          errorMessage,
        },
      }),
      backToOrigin,
    );
  };

  const openSecondaryPopup = () => {
    hidePopup();
    showPopup(
      generatePopupConfig(POPUP_TYPES.PROVIDER, {
        errorConfig: {
          errorType: footerOptions.secondaryPopup,
        },
        secondaryPopupCallback: secondaryPopupCallback,
      }),
      POPUP_TYPES.PROVIDER,
    );
  };
  return (
    <>
      {footerOptions.rgIcon && (
        <div className="footer-icon">
          <GenericIcon
            type="responsible_gambling"
            subtype={region as ResponsibleGamblingType}
            product={getIconProductType()}
          />
        </div>
      )}
      <div className="footer-message">
        <p data-testid={footerOptions.testIds?.text}>
          {footerOptions.messages.firstMessage}
          <span
            className="footer-action-message"
            data-testid={footerOptions.testIds?.action}
            onClick={openSecondaryPopup}
          >
            {footerOptions.messages.actionMessage}
          </span>
          {!errorCode || HIDE_FOOTER_ERROR_CODES.includes(errorCode) ? null : (
            <span>&nbsp;(Error {errorCode})</span>
          )}
        </p>
      </div>
    </>
  );
};

export default PopupFooter;
